import { useSelector } from '@xstate/store-react';

import { type UniversalFiltersStoreContext } from '../store.types';

import { useUniversalFiltersStore } from './useUniversalFiltersStore';

/**
 * Subscribes to a selected value from the provider-scoped filter store.
 */
export function useUniversalFiltersSelector<TSelected>(
  selector: (context: UniversalFiltersStoreContext) => TSelected,
) {
  const store = useUniversalFiltersStore();

  return useSelector(store, (snapshot) => selector(snapshot.context));
}
